import { Button, Component, _decorator } from 'cc';
import Delay from '../../Utils/Delay';
import Page from '../Page/Page';

const { ccclass, property, requireComponent } = _decorator;

enum EventType {
    CONFIRM = 'Confirm',
    CANCEL = 'Cancel',
}

@ccclass('Dialog')
@requireComponent(Page)
export default class Dialog extends Component {
    public static readonly EVENT_TYPE = EventType;

    @property(Button)
    public readonly confirmButton: Button = null;

    @property(Button)
    public readonly cancelButton: Button = null;

    @property
    protected readonly closeOnConfirm = true;

    @property
    protected readonly closeOnCancel = true;

    protected page: Page = null;

    public onLoad(): void {
        this.page = this.getComponent(Page);
        this.confirmButton?.node.on(Button.EventType.CLICK, () => {
            this.onConfirmButtonClick();
        });
        this.cancelButton?.node.on(Button.EventType.CLICK, () => {
            this.onCancelButtonClick();
        });
    }

    public async waitForConfirm() {
        if ((await this.waitForNextAction()) === Dialog.EVENT_TYPE.CONFIRM) {
            return Promise.resolve();
        }
        return Delay.forever();
    }

    public async waitForCancel() {
        if ((await this.waitForNextAction()) === Dialog.EVENT_TYPE.CANCEL) {
            return Promise.resolve();
        }
        return Delay.forever();
    }

    public waitForNextAction() {
        return Promise.race([
            Delay.event(Dialog.EVENT_TYPE.CONFIRM, this.node),
            Delay.event(Dialog.EVENT_TYPE.CANCEL, this.node),
            Delay.event(Page.EVENT_TYPE.CLOSE_START, this.node),
        ]);
    }

    protected onConfirmButtonClick() {
        this.node.emit(Dialog.EVENT_TYPE.CONFIRM);
        if (this.closeOnConfirm) {
            this.page.close();
        }
    }

    protected onCancelButtonClick() {
        this.node.emit(Dialog.EVENT_TYPE.CANCEL);
        if (this.closeOnCancel) {
            this.page.close();
        }
    }
}
